import Vue from 'vue'
import DataDict from '@/util/dict'
import { getDicts } from '@/api/system/dict.js'

function install() {
  Vue.use(DataDict, {
    metas: {
      '*': {
        labelField: 'dictLabel',
        valueField: 'dictValue',
        request(dictMeta) {
          return getDicts(dictMeta.type).then((res) => res.data)
        },
      },
    },
  })
}

export default {
  install,
}
